var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-navbar'),_c('app-sidebar'),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('app-loader'),_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }